export default {"src":"/_next/static/media/calendar-white.1e6f5d96.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};